// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {ModalProvider} from 'react-modal-hook';
import {Provider} from 'react-redux';
import {getGalleryDataCallback} from '~/GalleryPB/api/galleryData';
import {createGalleryStore} from '~/GalleryPB/reducers';
import {GalleryRoot} from './GalleryRoot';

const store = createGalleryStore({});
window.setGalleryDataCallback(getGalleryDataCallback(store));

export const GalleryRootWrapper = () => (
  <ModalProvider>
    <Provider store={store}>
      <GalleryRoot />
    </Provider>
  </ModalProvider>
);
